import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../OnboardingWizard.module.scss";

interface Props {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
}

const ProfileStep: React.FC<Props> = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.stepContent}>
      <h2 className={styles.stepTitle}>{t("onboarding.profileTitle")}</h2>
      <p className={styles.stepSubtitle}>{t("onboarding.profileSubtitle")}</p>

      <div className={styles.formFields}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel} htmlFor="firstName">
            {t("onboarding.firstName")}
          </label>
          <input
            id="firstName"
            type="text"
            className={styles.formInput}
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder={t("onboarding.firstNamePlaceholder")}
            autoFocus
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel} htmlFor="lastName">
            {t("onboarding.lastName")}
          </label>
          <input
            id="lastName"
            type="text"
            className={styles.formInput}
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder={t("onboarding.lastNamePlaceholder")}
          />
        </div>

      </div>
    </div>
  );
};

export default ProfileStep;
